import * as R from "ramda";

export const sortObjectKeys = R.compose(
  R.fromPairs,
  R.sortBy(R.prop(0)),
  R.toPairs
);
